module.exports = __webpack_public_path__ + "static/img/bb.95ff0af.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bb.png
// module id = 9f9D
// module chunks = 7